<template>
  <div v-if="filters && filters.length > 0" class="is-flex">
    <div
      :key="filter.designator"
      v-for="filter in filters"
      class="filter width-400"
    >
      <p>{{filter.designator}}</p>
      <div class="is-flex is-align-items-center white_space_no_wrap">
        <p>{{ filter.minValue || '0 KM' }}</p>
        <div class="horizontal_space"></div>
        <RangeBar
          @change="updateSingleFilter(filter, $event)"
          :default_value="$route.query[filter.designator]"
          :minValue="filter.minValue"
          :maxValue="filter.maxValue"
        />
        <div class="horizontal_space"></div>
        <p>{{ filter.maxValue || '100 KM' }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import FiltersHelper from '@/custom/classes/filters_helper.js'
import RangeBar from '@/components/RangeBar'
export default {
  name: 'range-filters',
  props: ['filters'],
  data () {
    return {
      filters_helper: new FiltersHelper()
    }
  },
  methods: {
    updateSingleFilter (filter, value) {
      let query = { ...this.$route.query }
      query[filter.designator] = value == '0' ? undefined : value
      this.$router.push({ path: this.$route.path, query: query })
    }
  },
  components: {
    RangeBar
  }
}
</script>
<style scoped>
  .filter{
    margin-right: 10px;
  }
  .width-400 {
    width: 400px;
  }
</style>
